module.exports = __webpack_public_path__ + "static/media/box3.04da1417.webp";